import { useQuery, UseQueryResult } from 'react-query'
import { useAppConfig } from '@components/providers/AppConfig'
import { get } from '@root/api'
import { defaultPricingConfig } from '@root/appData'

export type PricingConfigType = typeof defaultPricingConfig

export function usePricingConfigQuery(): UseQueryResult<PricingConfigType> {
	const { apiDomain } = useAppConfig()

	const query = useQuery(
		['pricing-config'],
		async () => {
			try {
				const res = await get(`${apiDomain}/api/globals/pricing-config`)

				if (res.status === 200) {
					const json = await res.json()

					// Validate that we have all required fields
					if (json.widthOptions && json.lengthOptions && json.depthOptions && json.addons) {
						return json as PricingConfigType
					}
				}

				// Fallback to default if API fails or returns incomplete data
				console.warn('Using default pricing config as fallback')
				return defaultPricingConfig
			} catch (error) {
				console.error('Error fetching pricing config:', error)
				return defaultPricingConfig
			}
		},
		{
			staleTime: 1000 * 60 * 60, // 1 hour
			cacheTime: 1000 * 60 * 60 * 24, // 24 hours
			refetchOnWindowFocus: false,
			refetchOnMount: false,
		}
	)

	return query
}
